/**
 * This function takes an array of strings (data) and a filename as parameters.
 * It creates a CSV-formatted string from the array, converts it to a Blob,
 * and then generates a download link to trigger the download.
 * @param {Array<string>} data
 * @param {string} filename
 */
export function downloadCSV(data: Array<string>, filename: string): void {
  const csv: string = data.join('\n');
  const blob: Blob = new Blob([csv], {type: 'text/csv'});
  const url: string = URL.createObjectURL(blob);

  const a: HTMLAnchorElement = document.createElement('a');
  a.href = url;
  a.download = filename;

  document.body?.appendChild(a);
  a.click();

  URL.revokeObjectURL(url);
  document.body?.removeChild(a);
}

export function createFileName(str: string, extension: string): string {
  const str1 = str.replace(/[^a-zA-Z0-9- ]/g, '');
  const fileName = `${str1.replace(/ /g, '-')}.${extension}`;
  return fileName;
}
